export default __webpack_public_path__ + "static/media/finance_active.7b2c9586.svg";